import * as Sentry from '@sentry/browser';
import * as angular from 'angular';
import 'angular-animate';
import 'angular-bootstrap';
import 'angular-loading-bar';
import 'angular-messages';
import 'angular-mocks';
import 'angular-moment';
import 'angular-resource';
import 'angular-route';
import 'angular-sanitize';
import 'angular-translate';
import 'angular-translate-loader-static-files';
import 'angular-ui-switch';
import 'angular-ui-validate';
import 'angular-utils-pagination';
import 'angular-wizard';
import 'animate.css';
import 'bootstrap';
import 'c3';
import 'checklist-model';
import 'components-font-awesome';
import 'd3';
import 'decimal.js';
import 'humanize-duration';
import 'intl-tel-input/build/js/intlTelInput-jquery';
import 'intl-tel-input/build/js/utils';
import 'jquery';
import 'jquery.ns-autogrow';
import 'moment';
import 'ng-intl-tel-input';
import 'ng-sortable';
import 'ng-tags-input';
import 'ngstorage';
import 'pkp-moment-timezone-all-years';
import 'remarkable-bootstrap-notify';
import 'sockjs-client';
import 'stacktrace-js';
import 'ui-select';
import { config } from 'angular/utils/config';
import 'app/css-imports';
import 'app/formular.module';
import 'app/ng-include-imports';
import { getBreadcrumbsForSentry } from '../../../../../src/utils/breadcrumbs';

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://f52f114c1e964a238c9568aa118af923@sentry.io/1883228',
        release: process.env.CI_COMMIT_SHA,
        environment: config.stage,
        beforeSend(event, hint) {
            const error = hint && hint.originalException;

            // ignore "$digest already in progress":
            // those are super hard to track down, usually harmless and can happen just by
            // navigating through the platform
            if (
                error &&
                typeof (error as any).message === 'string' &&
                (error as any).message.startsWith(
                    '[$rootScope:inprog] $digest already in progress'
                )
            )
                return null;

            // this error doesn't seem to happen for real users, but is somehow caused by
            // crawlers and adds a lot of noise
            if (
                error &&
                typeof (error as any).message === 'string' &&
                (error as any).message ===
                    'In this configuration Angular requires Zone.js'
            )
                return null;

            // ignore network errors
            if (
                error &&
                (error as any).name === 'HttpErrorResponse' &&
                (error as any).status === 0
            )
                return null;

            // Group Errors With Greater Granularity
            // see https://docs.sentry.io/platforms/javascript/data-management/event-grouping/sdk-fingerprinting/#group-errors-with-greater-granularity
            if (error && typeof (error as any).stack === 'string') {
                event.fingerprint = [
                    '{{ default }}',
                    (error as any).stack.split('\n')[0] +
                        (error as any).stack.split('\n')[1] || ''
                ];
            }

            event.extra = {
                ...event.extra,
                breadcrumbs: getBreadcrumbsForSentry()
            };

            return event;
        }
    });
}

angular.module('app', [
    'ngRoute',
    'ui.bootstrap',
    'ngIntlTelInput',
    'uiSwitch',
    'formular',
    'ngMessages',
    'ngResource',
    'ngStorage',
    'ngAnimate',
    'angular-loading-bar',
    'as.sortable',
    'angularUtils.directives.dirPagination',
    'ngSanitize',
    'pascalprecht.translate',
    'angularMoment',
    'mgo-angular-wizard',
    'ui.select',
    'ui.validate',
    'checklist-model',
    'ngTagsInput'
]);

// require all .ts files in directory and subdirectories (but not .d.ts)

// @ts-ignore
const context = require.context('.', true, /^(?!.*\.d\.ts$).*\.ts$/);
context.keys().forEach(function (key) {
    context(key);
});
